import { getCountriesGeo } from "@services/info";
import SignUpContainer from "containers/SignUp/SignUpContainer";
import withPublic from "utils/withPublic";

export default withPublic(SignUpContainer, async (props) => {
  try {
    const countries = await getCountriesGeo();
    return {
      ...props,
      valid: true,
      countries,
    };
  } catch (e) {
    return {
      ...props,
      valid: true,
      countries: [],
    };
  }
});
